<p-select
  [ngModel]="localSelected()"
  (ngModelChange)="onSelectionChange($event)"
  [options]="options()"
  optionLabel="label"
  optionValue="value"
  [filter]="true"
  filterBy="searchKey"
  i18n-filterPlaceholder="@@voicePicker.searchPlaceholder"
  filterPlaceholder="Search by name or description..."
  i18n-placeholder="@@voicePicker.placeholder"
  placeholder="Select a voice"
  [showClear]="true"
  [loading]="isLoading()"
  [disabled]="disabled() || isLoading() || !modelVersionId() || options().length === 0"
  styleClass="w-full">

  <ng-template let-option pTemplate="item">
    <div class="voice-option">
      <span class="voice-name">{{ option.label }}</span>
      @if (option.description) {
        <small class="voice-description">{{ option.description }}</small>
      }
    </div>
  </ng-template>

  <ng-template let-option pTemplate="selectedItem">
    <span class="voice-selected-name">{{ option.label }}</span>
  </ng-template>
</p-select>

@if (loadError()) {
  <small class="voice-error" i18n="@@voicePicker.loadError">Failed to load voices for this model version.</small>
}
